import { isValidElement } from "react";
export function hasRenderableReactContent(node) {
    if (node === null || node === undefined || node === false)
        return false;
    if (typeof node === "boolean")
        return false;
    if (typeof node === "string")
        return node.trim().length > 0;
    if (typeof node === "number")
        return true;
    if (Array.isArray(node))
        return node.some(hasRenderableReactContent);
    if (isValidElement(node)) {
        if (typeof node.type === "string") {
            return hasRenderableReactContent(node.props.children);
        }
        return true;
    }
    return false;
}
